import { Radio, Section } from '@factorialco/deprecated-design-system'
import {
  AtsMessageTemplateVisibilityEnum,
  AtsMessageTemplateVisibilitySectionFormFragment,
  AtsUpdateMessageTemplateVisibilityDocument,
} from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { Visibility } from 'modules/ats/lib/enums'

interface EditTemplateVisibilityFormValues {
  visibility: AtsMessageTemplateVisibilityEnum
}

interface Props {
  messageTemplate: AtsMessageTemplateVisibilitySectionFormFragment
  canEdit: boolean
}

export const VisibilitySectionForm = ({ messageTemplate, canEdit }: Props) => {
  const [updateAtsMessageTemplateVisibility, { loading }] = useMutation(
    AtsUpdateMessageTemplateVisibilityDocument,
    { extractorFn: (data) => data.atsMutations.updateAtsMessageTemplate }
  )
  const { id: messageTemplateId, visibility } = messageTemplate

  const { values, setFieldValue, dirty, handleSubmit, resetForm } =
    useForm<EditTemplateVisibilityFormValues>({
      defaultValues: {
        visibility,
      },
      async onSubmit(data, { setErrors }) {
        const result = await updateAtsMessageTemplateVisibility({
          variables: {
            id: messageTemplateId,
            visibility: data.visibility,
          },
        })

        const handled = handleResult(result, (resultErrors) => {
          setErrors(resultErrors)
        })

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.saved_successfully'),
          })

          resetForm({ values })
        }

        return handled
      },
    })

  return (
    <Section.Form
      illustration="sign-post"
      title={i18n.t('ats.manage_message_templates.template_form.visibility_title')}
      description={i18n.t('ats.manage_message_templates.template_form.visibility_description')}
      submitLabel={i18n.t('common.apply')}
      isDirty={dirty}
      onSubmit={handleSubmit}
      disabled={loading}
    >
      <Radio
        name="company"
        description={i18n.t(
          'ats.manage_message_templates.template_form.visibility_company_description'
        )}
        option={{
          label: i18n.t('ats.manage_message_templates.template_form.visibility_company_label'),
          value: 'company',
          disabled: !canEdit,
        }}
        value={values.visibility}
        onChange={(value) => setFieldValue('visibility', value)}
      />
      <Radio
        name="personal"
        description={i18n.t(
          'ats.manage_message_templates.template_form.visibility_personal_description'
        )}
        option={{
          label: i18n.t('ats.manage_message_templates.template_form.visibility_personal_label'),
          value: 'personal',
          disabled: !canEdit,
        }}
        value={values.visibility}
        onChange={(value) => setFieldValue('visibility', value)}
      />
    </Section.Form>
  )
}
